<template>
	
  <div id="app">
    <div class="header">
      <div class="logo_img" @click="logoClick">
        <div style="display:flex; align-items: center; float:left; height: 65px;">
          <div class="header-logo">
            <img id="header-img" src="../assets/logo1.png">
          </div>
        </div>
      </div>
      <div id="menu_index">
        <!-- web端菜单导航 -->
        <el-menu
          v-if="seen"
          :default-active="activeIndex"
          class="el-menu-demo"
          menu-trigger="click"
          text-color="#333"
          style="height: 65px; border:0;"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="1" class="header-title">最新活动</el-menu-item>
          <el-menu-item index="2" class="header-title">首页</el-menu-item>
          <!-- <el-submenu index="2">
                        <template slot="title">产品与解决方案</template>
                        <el-menu-item index="2-1">产品微观</el-menu-item>
          </el-submenu>-->
          <el-menu-item index="3" class="header-title">成功案例</el-menu-item>
          <el-menu-item index="4" class="header-title">解决方案</el-menu-item>
          <el-menu-item index="5" class="header-title">产品价格</el-menu-item>
          <el-menu-item index="6" class="header-title">关于我们</el-menu-item>
        </el-menu>
      </div>
      <div v-if="seen" style="float: right; display: flex;align-items: center; height: 100%;">
        <el-button
          type="text"
          style="margin-right: 20px;color:#000;"
          class="header-title"
          @click="login"
        >登录</el-button>
        <el-button
          type="primary"
          size="mini"
          class="header-title"
          style="color:#fff;font-size: 13px;background: #0066FF;padding:8px 20px"
          @click="register"
        >免费试用</el-button>
        <el-button type="text" style="margin-left: 24px;color:#000;" class="header-title" @click="wechat()">在线客服</el-button>
      </div>
    </div>
	
	<!-- 悬浮标题 -->
	
	
    <div class="container" style="clear: both;">
		
      <router-view></router-view>
      
     <!-- <div class="floatRight">
        <img
          src="../assets/imgs/Vectorqy@2x.png"
          alt=""
          v-on:mouseover="getMoves($event)"
          v-on:mouseout="removegetMoves($event)"
        >
        <span style="width: 32px;;border-bottom: 1px solid #E2E6F0;"></span>
        <img
          src="../assets/imgs/Vectorqy@2x.png"
          alt=""
          v-on:mouseover="getMove($event)"
          v-on:mouseout="removegetMove($event)"
        >
        <span style="width: 32px;;border-bottom: 1px solid #E2E6F0;"></span>
        <img src="../assets/imgs/Vector(1)2x.png" alt="">
        <span style="width: 32px;;border-bottom: 1px solid #E2E6F0;"></span>
        <img src="../assets/imgs/Vectoryx@2x.png" alt="">
        <span style="width: 32px;;border-bottom: 1px solid #E2E6F0;"></span>
        <img src="../assets/imgs/Vectorxs@2x.png" alt=""> 
      </div>
      <div class="ew_m" v-show="showWX">
        <img src="../assets/imgs/qywx.png" alt="">
      </div>
      <div class="ew_m" v-show="showWXs">
        <img src="../assets/imgs/grwx.png" alt="">
      </div>
     <div class="floatRightLeft">
        <el-button
          type="primary"
          size="mini"
          class="header-title"
          style="color:#fff;font-size: 13px;background: #0066FF;padding:8px 20px"
          @click="onGokf"
        >联系客服</el-button>
      </div> -->
    </div>
	
	
	
	
	
	
    <!-- 底部信息 -->
    <div style="    position: relative;
    display: flex;
    justify-content: space-around;max-width: 1980px;max-height: 300px;">
      <img src="../assets/imgs/bottonbag.png" alt="" style="max-width: 100%;">
      <div class="bottom_t">
        <span>为您提供出众的上云实践机会和全面的尊贵服务</span>
        <el-button type="primary" class="header-title" style="color:#fff;background: #0066FF;" @click="register">免费注册</el-button>
      </div>
    </div>
    <div style="width: 100%;">
      <el-row>
        <el-col :xs="24" :sm="24">
          <div class="forlist">
            <div>7*24小时服务支持</div>
            <span style="height: 31px;border-right: 2px solid #E2E6F0;"></span>
            <div>自动巡检系统</div>
            <span style="height: 31px;border-right: 2px solid #E2E6F0;"></span>
            <div>秒级切换节点</div>
            <span style="height: 31px;border-right: 2px solid #E2E6F0;"></span>
            <div>5天未消耗无理由退款</div>
          </div>
          <div class="bottomList">
            <div class="bottomList_Left">
              <img src="../assets/imgs/bottomlog.png" alt="">
              <div class="bottomList_Leftp">济宁易凡云网络科技有限公司</div>
              <div class="bottomList_Leftb">
                <img src="../assets/imgs/Groupone.png" alt="">
                <img src="../assets/imgs/Grouptwo.png" alt="">
                <img src="../assets/imgs/Groupthree.png" alt="">
                <img src="../assets/imgs/Groupfour.png" alt="">
              </div>
            </div>
            <div class="bottomList_right">
              <div>
                <span>产品与服务</span>
                <span>融合CDN</span>
                <span>对象存储</span>
                <span>海外CDN</span>
              </div>
              <div>
                <span>帮助与支持</span>
                <span>在线客服</span>
                <span>投诉中心</span>
                <span>管理控制台</span>
              </div>
              <div>
                <span>关于我们</span>
                <span>公司简介</span>
                <span>新闻动态</span>
                <span>友情链接</span>
              </div>
            </div>
          </div>
          <div class="btdetail" on-click="icp()">
            <div>Copyright @ 2001-2018 www.yifancloud.cn.AIl Rights Reserved. 济宁易凡云网络科技有限公司 版权所有</div>
            <div><a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2020036097号-1&nbsp;&nbsp;&nbsp;</a>
			增值电信业务许可证：B1-20210420	
			</div>
			
			
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 置顶按钮 -->
    <div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
      <p style="font-size: 0.625em; font-weight: bold">TOP</p>
      <img src="../assets/other/launch.png" style="height: 45px;width: 35px">
    </div>
  </div>
</template>



=
<script>
	 
	  
export default {
  name: "Layout",
  data() {
    return {
      activeIndex: "2",
      company: {
        qrcode: require("../../static/other/公众号二维码.jpg")
      },
      scroll: "",
      timer: "",
      seen: true,
      currentMenu: "首页",
      showWX: false,
      showWXs: false
    };
  },
  methods: {
    getMove() {
      this.showWX = true;
    },
    removegetMove() {
      this.showWX = false;
    },
    getMoves() {
      this.showWXs = true;
    },
    removegetMoves() {
      this.showWXs = false;
    },
    onGokf() {
      window.location.href =
        "https://wpa1.qq.com/ZYoAZfMt?_type=wpa&qidian=true";
    },
	wechat() {
	  window.location.href =
	    "https://wpa1.qq.com/ZYoAZfMt?_type=wpa&qidian=true";
	},
	icp() {
	  window.location.href =
	    "https://tsm.miit.gov.cn/";
	},
    handleSelect(key) {
      switch (key) {
        case "1":
          this.$router.push({ name: "latestActivities" });
          break;
        case "2":
          this.$router.push({ name: "Index" });
          break;
        case "3":
          this.$router.push({ name: "successCases" });
          break;
        case "4":
          this.$router.push({ name: "solution" });
          break;
        case "5":
          this.$router.push({ name: "productPrice" });
          break;
        case "6":
          this.$router.push({ name: "aboutUs" });
          break;
      }
    },
    handleScroll() {
      this.scroll =
        document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
      if (this.scroll > 600) {
        //判断滚动后高度超过400px,就显示
        this.$refs.btn.style.display = "block";
      } else {
        this.$refs.btn.style.display = "none";
      }
    },
    backTop() {
      //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
      this.timer = setInterval(() => {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(this.timer);
        }
      }, 30);
    },
    login() {
      window.open("https://cdn-admin.yifancloud.cn/user/login");
    },
    register() {
      window.open("https://cdn-admin.yifancloud.cn/user/register");
    },
    menuSeen() {
      // 屏幕尺寸
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        this.seen = true;
      } else {
        this.seen = false;
      }
    },
    logoClick() {
      this.$router.push({ name: "Index" });
      this.currentMenu = "首页";
    }
  },
  mounted() {
    this.menuSeen();
    window.addEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped>
.ew_m {
  position: fixed;
  top: 20.5%;
  z-index: 1000;
  opacity: 1;
  right: 3%;
  display: flex;
  width: 344px;
  height: 464px;
  justify-content: center;
  background: #ffffff;
  padding-top: 10px;
}
.btdetail {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
  background: #f6f7fa;
}
.btdetail div {
  font-size: 14px;
  font-family: PingFang SC-Medium, PingFang SC;
  color: #848b99;
  font-weight: 500;
}
.forlist {
  display: flex;
  flex-direction: row;
  background: #f6f7fa;
  align-items: center;
  justify-content: space-evenly;
  height: 70px;
  border-bottom: 1px solid #e2e6f0;
}
.bottomList {
  display: flex;
  background: #f6f7fa;
  align-items: center;
  justify-content: space-evenly;
  height: 304px;
  border-bottom: 1px solid #e2e6f0;
}
.bottomList .bottomList_Left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.bottomList .bottomList_Left .bottomList_Leftp {
  margin: 26px 0 31px 0;
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 16px;
}
.bottomList .bottomList_Left .bottomList_Leftb {
  width: 260px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}
.bottomList .bottomList_Left .bottomList_Leftb img{
  width: 31px;
}
.bottomList .bottomList_right {
  display: flex;
  width: 50%;
  cursor: pointer;
  justify-content: space-between;
}
.bottomList .bottomList_right div {
  display: flex;
  flex-direction: column;
  height: 193px;
  justify-content: space-around;
  font-size: 16px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #585f69;
  line-height: 48px;
}
.bottom_t {
  position: absolute;
  top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.bottom_t span {
  font-size: 24px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #0066ff;
  line-height: 24px;
  margin-bottom: 28px;
}
.floatRight {
  position: fixed;
  top: 50%;
  z-index: 1000;
  right: 10px;
  display: flex;
  width: 40px;
  height: 163px;
  background: #ffffff;
  opacity: 1;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  transition: 0.3s;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  cursor: pointer;
}
.floatRight img {
  width: 20px;
  height: 16px;
}
.floatRightLeft {
  position: fixed;
  top: 59.5%;
  z-index: 1000;
  right: 110px;
  width: 40px;
  height: 143px;
  opacity: 1;
}
.logo_img {
  float: left;
  width: 6%;
  cursor: pointer;
}
#back_to_top {
  position: fixed;
  bottom: 50px;
  right: 30px;
  cursor: pointer;
}
.header-title {
  font-size: 1em;
}
.company_name {
  font-weight: normal;
  font-size: 1em;
}
.footer_font {
  font-size: 1em;
}
#menu_index {
  float: left;
  width: 50%;
  height: 100%;
}
.header {
  margin: auto;
  width: 90%;
  height: 65px;
  /*background: #F56C6C;*/
}
.el-menu-item {
  border-bottom: 3px solid #409eff;
  color: #303133;
  margin-top: 5px;
}
@media screen and (max-device-width: 415px) {
  .logo_img {
    float: left;
    width: auto;
    cursor: pointer;
  }
  #back_to_top {
    position: fixed;
    bottom: 50px;
    right: 5px;
    cursor: pointer;
  }
  .footer_font {
    font-size: 0.875em;
  }
  #menu_index {
    float: right;
    width: auto;
    height: 100%;
  }
  .mobile_menu {
  }
}
#header-img {
  width: 50px;
  height: 50px;
  float: left;
  margin: auto;
}
.header-logo {
  height: 50px;
  width: 50px;
  align-self: center;
}
.header-important {
  float: left;
  margin-left: 6px;
  align-self: center;
}

.footer {
  display: flex;
  align-items: center;
  margin: 10px auto;
  width: 90%;
}
a {
  text-decoration: none;
}
a:visited {
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}
a:active {
  text-decoration: none;
}
</style>